// extracted by mini-css-extract-plugin
export default {"Account":"Header_Account__WzRbQ","AccountP":"Header_AccountP__H1rqJ"};